import {MultimediaDownloadInfo} from '@/types/matrix';
import axios from 'axios';
import saveAs from 'file-saver';
import JSZip from 'jszip';

export const downloadMultipleMultimedia = async (
  multimediaInfo: MultimediaDownloadInfo[]
) => {
  const zip = new JSZip();

  const addMultimediaToZip = async (
    info: MultimediaDownloadInfo,
    index: number
  ) => {
    const multimediaType = info.type;
    const mimeType = info.mimeType;

    const fileExtension = mimeType.split('/')[1];
    const fileName = `${multimediaType}_${index}.${fileExtension}`;

    try {
      const response = await axios({
        url: info.url,
        method: 'GET',
        responseType: 'blob'
      });
      zip.file(fileName, response.data);
    } catch (error) {
      console.error('Error while downloading file: ', error);
    }
  };
  await Promise.all(multimediaInfo.map(addMultimediaToZip));
  zip.generateAsync({type: 'blob'}).then((content) => {
    saveAs(content, 'downloaded_multimedia.zip');
  });
};
